/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'

export const initToastsState: Redux.ToastState = []

function addToastAction(
  state: typeof initToastsState,
  action: PayloadAction<Redux.ToastItem>
) {
  return [...state, action.payload]
}

function removeToastAction(
  state: typeof initToastsState,
  action: PayloadAction<number>
) {
  const removeIdx = action.payload

  if (removeIdx) {
    return [...state.slice(0, removeIdx), ...state.slice(removeIdx + 1)]
  }

  return []
}

function resetAction() {
  return initToastsState
}

export const toastsSlice = createSlice({
  name: 'toasts',
  initialState: initToastsState,
  reducers: {
    addToast: addToastAction,
    removeToast: removeToastAction,
    resetToasts: resetAction,
  },
})

export const selectSelf = (state: Redux.RootState) => state

export const toastsSelector = createSelector(selectSelf, state => state.toasts)

export const { addToast, removeToast, resetToasts } = toastsSlice.actions

export default toastsSlice.reducer
